"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexedDBDriver = void 0;
var intersection_1 = __importDefault(require("lodash/intersection"));
var debug_1 = __importDefault(require("debug"));
var utils_1 = require("../utils");
var log = debug_1.default('persie:indexeddb');
var lastAccessTimeIndexName = 'lastAccessed';
var IndexedDBDriver = /** @class */ (function () {
    function IndexedDBDriver(dbName, objectStoreNames, dbVersion) {
        this.dbName = dbName;
        this.objectStoreNames = objectStoreNames;
        this.dbVersion = dbVersion;
        this.db = undefined;
    }
    IndexedDBDriver.deleteDB = function (dbName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                log("Deleting " + dbName + " db");
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var request = indexedDB.deleteDatabase(dbName);
                        request.onsuccess = function () { return resolve(request.result); };
                        request.onerror = function (event) { return reject(event); };
                    })];
            });
        });
    };
    IndexedDBDriver.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                var request = indexedDB.open(_this.dbName, _this.dbVersion);
                                request.onupgradeneeded = function (event) {
                                    var db = request.result;
                                    var oldVersion = event.oldVersion;
                                    if (oldVersion !== 0) {
                                        var oldStoresToDelete = intersection_1.default(db.objectStoreNames, _this.objectStoreNames);
                                        oldStoresToDelete.forEach(function (store) { return db.deleteObjectStore(store); });
                                    }
                                    _this.objectStoreNames.forEach(function (objectStoreName) {
                                        var store = db.createObjectStore(objectStoreName, { keyPath: 'key' });
                                        store.createIndex(lastAccessTimeIndexName, 'lastAccessed');
                                    });
                                };
                                request.onsuccess = function () {
                                    var db = request.result;
                                    db.onversionchange = function (event) {
                                        // 2 cases for this 2 happen: 
                                        // 1) site is opened in a new tab and it tries to update the existing DB
                                        // 2) we are trying to delete DB while it is open by another instance. (newVersion will be null in this case probably)
                                        var oldVersion = event.oldVersion, newVersion = event.newVersion;
                                        log("onversionchange: parallel update attempt from " + oldVersion + " to " + newVersion);
                                        // TODO: this should probably trigger a window.location.reload()
                                        db.close();
                                    };
                                    resolve(db);
                                };
                                request.onerror = function (event) { return reject(event); }; // TODO: this may happen if user loads outdated code, i.e. try to load older version of DB so we need to catch and tell user to refresh
                                request.onblocked = function (event) {
                                    // This will happen if we do not handle onversionchange correctly
                                    log('onblocked: old connection was not closed closed!');
                                    reject(event);
                                };
                            })];
                    case 1:
                        _a.db = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBDriver.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.db) {
                    this.db.close();
                    this.db = undefined;
                }
                return [2 /*return*/];
            });
        });
    };
    IndexedDBDriver.prototype.freeMemory = function (byteSizeToFree, objectStore) {
        return __awaiter(this, void 0, void 0, function () {
            var startTs;
            var _this = this;
            return __generator(this, function (_a) {
                startTs = Date.now();
                log("Free memory for " + byteSizeToFree);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!_this.db) {
                            return reject(new Error('DB not initialized'));
                        }
                        if (byteSizeToFree <= 0) {
                            return resolve(0);
                        }
                        var transaction = _this.db.transaction(objectStore, 'readwrite');
                        var assets = transaction.objectStore(objectStore);
                        var lastAccessedTimeIndex = assets.index(lastAccessTimeIndexName);
                        var indexRequest = lastAccessedTimeIndex.openCursor(); // default is ascending so we get the oldest record (based on lastAccessedTime) first
                        var accumulatedByteSize = 0;
                        var assetKeysToFree = [];
                        var foundBlocksToDelete = false;
                        indexRequest.onsuccess = function () {
                            var cursor = indexRequest.result;
                            if (cursor) {
                                var key = cursor.primaryKey;
                                var asset = cursor.value;
                                //if data is not array buffer we are not supporting size calculations for now.
                                var assetSize = asset.data instanceof ArrayBuffer ? asset.data.byteLength : 0;
                                accumulatedByteSize += assetSize;
                                assetKeysToFree.push(key);
                                if (accumulatedByteSize < byteSizeToFree) {
                                    cursor.continue();
                                }
                                else {
                                    foundBlocksToDelete = true;
                                }
                            }
                            if (foundBlocksToDelete) {
                                log("Removing assets with keys " + assetKeysToFree + " to free " + accumulatedByteSize);
                                assetKeysToFree.forEach(function (key) { return assets.delete(key); });
                            }
                            else if (!cursor) {
                                // we only end up here if we could not find enough blocks to delete
                                log("Free memory fail: can free up to " + accumulatedByteSize + " bytes");
                            }
                        };
                        transaction.oncomplete = function () {
                            if (foundBlocksToDelete) {
                                // resolve iff we can satisfy memory requirement to delete
                                return resolve(accumulatedByteSize);
                            }
                            return reject(new Error('Cannot free enough memory!'));
                        };
                        transaction.onerror = function (event) { return reject(event); };
                        transaction.onabort = function (event) { return reject(event); };
                    }).then(function (res) {
                        log("Free memory took: " + utils_1.timeDelta(startTs) + "s");
                        return res;
                    }).catch(function (err) {
                        log("Free memory fail took: " + utils_1.timeDelta(startTs) + "s");
                        throw err;
                    })];
            });
        });
    };
    IndexedDBDriver.prototype.getItem = function (key, objectStore) {
        return __awaiter(this, void 0, void 0, function () {
            var startTs;
            var _this = this;
            return __generator(this, function (_a) {
                startTs = Date.now();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!_this.db) {
                            return reject(new Error('DB not initialized'));
                        }
                        var transaction = _this.db.transaction(objectStore, 'readwrite');
                        var assets = transaction.objectStore(objectStore);
                        var readRequest = assets.get(key);
                        var dataResponse;
                        readRequest.onsuccess = function () {
                            var data = readRequest.result;
                            if (data) {
                                data.lastAccessed = new Date();
                                assets.put(data);
                            }
                            dataResponse = data;
                        };
                        transaction.oncomplete = function () { return resolve(dataResponse); };
                        transaction.onerror = function (event) { return reject(event); };
                        transaction.onabort = function (event) { return reject(event); };
                    }).then(function (res) {
                        var _a;
                        if (res) {
                            log("getItem took " + utils_1.timeDelta(startTs) + "s:", res.key, (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.byteLength) || 0) / 1000);
                        }
                        return res;
                    })];
            });
        });
    };
    IndexedDBDriver.prototype.getAllItems = function (objectStore) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!_this.db) {
                            return reject(new Error('DB not initialized'));
                        }
                        var transaction = _this.db.transaction(objectStore, 'readonly');
                        var assets = transaction.objectStore(objectStore);
                        var items = assets.getAll();
                        transaction.oncomplete = function () { return resolve(items.result); };
                        transaction.onerror = function (event) { return reject(event); };
                        transaction.onabort = function (event) { return reject(event); };
                    })];
            });
        });
    };
    IndexedDBDriver.prototype.storeItem = function (key, data, metadata, objectStore) {
        return __awaiter(this, void 0, void 0, function () {
            var startTs;
            var _this = this;
            return __generator(this, function (_a) {
                startTs = Date.now();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!_this.db) {
                            return reject(new Error('DB not initialized'));
                        }
                        var transaction = _this.db.transaction(objectStore, 'readwrite');
                        var assets = transaction.objectStore(objectStore);
                        var dataToSave = {
                            key: key,
                            data: data,
                            metadata: metadata,
                            lastAccessed: new Date()
                        };
                        assets.put(dataToSave);
                        transaction.oncomplete = function () {
                            resolve(dataToSave);
                        };
                        transaction.onerror = function (event) { return reject(event); };
                        transaction.onabort = function (event) { return reject(event); };
                    }).then(function (res) {
                        var _a;
                        if (res) {
                            log("storeItem took " + utils_1.timeDelta(startTs) + ":", res.key, (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.byteLength) || 0) / 1000);
                        }
                        return res;
                    })];
            });
        });
    };
    IndexedDBDriver.prototype.clearDB = function (onlyOwnStores) {
        if (onlyOwnStores === void 0) { onlyOwnStores = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!_this.db) {
                            return reject(new Error('DB not initialized'));
                        }
                        var objectStoreList = onlyOwnStores ? _this.objectStoreNames : Array.from(_this.db.objectStoreNames);
                        var transaction = _this.db.transaction(objectStoreList, 'readwrite');
                        log("Clearing object stores: " + objectStoreList + " in " + _this.dbName + " db");
                        objectStoreList.forEach(function (objectStoreName) {
                            var objectStore = transaction.objectStore(objectStoreName);
                            objectStore.clear();
                        });
                        transaction.oncomplete = function () { return resolve(objectStoreList); };
                        transaction.onerror = function (event) { return reject(event); };
                        transaction.onabort = function (event) { return reject(event); };
                    })];
            });
        });
    };
    // This should be last resort, better to use clearDB which only clears the data in object stores.
    IndexedDBDriver.prototype.deleteDB = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, IndexedDBDriver.deleteDB(this.dbName)];
            });
        });
    };
    return IndexedDBDriver;
}());
exports.IndexedDBDriver = IndexedDBDriver;
